<template>
  <div>
    <ul class="container">
      <li v-for="(conf, index) in confsMobile"
      :key="index">
        <a :href="conf.link" target="_blank">
          <img :src="conf.img" alt="">
        </a>
      </li>
    </ul>
    <!-- <div class="pc-container" v-else>
      <img src="https://static.geekbang.org/infoq/5afd374e67d8d.png?imageView2/0/" alt="">
      <ul class="pc1">
        <li v-for="(conf, index) in confsPC"
        :key="index">
          <a :href="conf.link" target="_blank">
            <img :src="conf.img" alt="">
          </a>
        </li>
      </ul>
      <ul class="pc2">
        <li v-for="(conf, index) in confsPC2"
        :key="index">
          <a :href="conf.link" target="_blank">
            <img :src="conf.img" alt="">
          </a>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
import utils from '@/util/WXshare'
export default {
  data () {
    return {}
  },
  computed: {
    confsMobile () {
      return [{
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5a9e3de961980.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5a9e3de8ee84f.png?imageView2/0/'
      }, {
        link: 'https://2018.qconbeijing.com',
        img: 'https://static.geekbang.org/infoq/5a9e3de735325.png?imageView2/0/'
      }, {
        link: 'https://gtlc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5a9e3de76b7bc.png?imageView2/0/'
      }, {
        link: 'https://gmtc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5a9e3de7a3d76.png?imageView2/0/'
      }, {
        link: 'https://sz2018.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5a9e3de7e1c48.png?imageView2/0/'
      }, {
        link: 'https://bccon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afc1a4300569.png?imageView2/0/'
      }, {
        link: 'https://2018.qconshanghai.com',
        img: 'https://static.geekbang.org/infoq/5a9e3de84a86e.png?imageView2/0/'
      }, {
        link: 'http://www.cnutcon.com',
        img: 'https://static.geekbang.org/infoq/5a9e3de888b9d.png?imageView2/0/'
      }, {
        link: 'https://bj2017.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5a9e452e77302.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5a9e452eb314d.png?imageView2/0/'
      }, {
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5a9e4c8c542ac.png?imageView2/0/'
      }]
    },
    confsPC () {
      return [{
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5afd33a098997.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a1606ba.png?imageView2/0/'
      }, {
        link: 'https://2018.qconbeijing.com',
        img: 'https://static.geekbang.org/infoq/5afd33a0d159c.png?imageView2/0/'
      }, {
        link: 'https://gtlc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a126d33.png?imageView2/0/'
      }, {
        link: 'https://gmtc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a1b4593.png?imageView2/0/'
      }, {
        link: 'https://sz2018.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5afd33a208b35.png?imageView2/0/'
      }]
    },
    confsPC2 () {
      return [{
        link: 'https://bccon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a2b5f18.png?imageView2/0/'
      }, {
        link: 'https://2018.qconshanghai.com',
        img: 'https://static.geekbang.org/infoq/5afd33a2708de.png?imageView2/0/'
      }, {
        link: 'http://www.cnutcon.com',
        img: 'https://static.geekbang.org/infoq/5afd33a316eb9.png?imageView2/0/'
      }, {
        link: 'https://bj2017.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5afd38ef06b1c.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd38ef7182a.png?imageView2/0/'
      }, {
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5afd38eeb1357.png?imageView2/0/'
      }]
    }
  },
  mounted () {
    utils.shareInWeixin({
      timelineTitle: '2018极客邦科技年度主要活动',
      messageTitle: '2018极客邦科技年度主要活动',
      desc: '2018年度技术人参会攻略'
    })
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

img
  vertical-align: middle

.pc-container
  width: 100%
  display: flex
  flex-direction: column
  ul.pc1
    li
      float: left
      a
        display: block
        img
          height: 138px
  ul.pc2
    li
      float: left
      a
        display: block
        img
          height: 163.412222222px

+tablet
  .container
    width: 50vw

.container
  ul
    li:first-child,li:last-child
      a
        cursor: default
        img
          vertical-align: baseline

</style>


// WEBPACK FOOTER //
// confs.vue?0041d7bf